import { create } from "zustand";

// Reactive signal for localStorage-backed action-flag dismissals — the same pattern (and reason) as
// recSetsBus: localStorage is not a React dependency, so the flag pills and the Action-Flag filter would
// cache a stale snapshot after a dismissal until an unrelated re-render. lib/flagDismissals bumps this on
// every write; consumers include the version in memo deps.
interface FlagDismissBus {
  version: number;
  bump: () => void;
}

export const useFlagDismissBus = create<FlagDismissBus>((set) => ({
  version: 0,
  bump: () => set((s) => ({ version: s.version + 1 })),
}));
